/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useApiClient from "hooks/useApiClient";
import { useMessage } from "states/messageContext";
import { square } from "ldrs";
import useMimir from "hooks/useMimir";
import CommonBanner from "component/Common/CommonBanner";
square.register();
const ConfirmOrderPage = () => {
    const { api, urls } = useApiClient();
    const [searchParams] = useSearchParams();
    const orderNumber = searchParams.get("orderNumber");
    const type = searchParams.get("type") || "AIR";
    const { showMessage } = useMessage();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { mimir } = useMimir();

    const buildMimirPayload = (result) => {
        return {
            type: "FLIGHT",
            event: "EPAYMENT",
            param1: orderNumber,
            param2: JSON.stringify(result || {}),
        };
    };

    const displayErrorMessage = (payment) => {
        let errorMessage = "";
        let errorTitle = t("paymentError");

        if (
            payment.params?.respCode_desc &&
            payment.params.respCode_desc !== ""
        ) {
            errorMessage = payment.params.respCode_desc;
        } else if (payment.actionCodeDescription) {
            errorMessage = payment.actionCodeDescription;
        }

        if (
            payment.params?.respCode === "00" &&
            payment.params?.ErrorCode === "0" &&
            Number(payment.params?.OrderStatus) === 3
        ) {
            errorMessage =
                "Votre transaction a été rejetée / Your transaction was rejected / تم رفض معاملتك";
        }

        if (!errorMessage) {
            errorMessage =
                payment.ErrorMessage ||
                "Votre transaction a été rejetée / Your transaction was rejected / تم رفض معاملتك";
        }

        showMessage({
            text: errorMessage,
            type: "error",
            title: errorTitle,
        });
    };

    useEffect(() => {
        if (orderNumber) {
            const queryParams = new URLSearchParams();
            queryParams.append("orderNumber", orderNumber);
            queryParams.append("language", i18n.language);
            const requestUrl = `${urls.flight.confirmOrder}?${queryParams}`;
            let result;
            api.get(requestUrl)
                .then((res) => {
                    const data = res.data;
                    result = data;
                    if (
                        !data?.payment ||
                        (data?.result &&
                            data?.result["IBE_Errors"]?.includes(
                                "PAYMENT_ERROR",
                            ))
                    ) {
                        showError();
                        return;
                    }
                    if (
                        !(
                            data?.payment?.OrderStatus === 2 &&
                            data?.payment?.params?.respCode === "00"
                        )
                    ) {
                        displayErrorMessage(data?.payment);
                        navigate("/");
                        return;
                    }

                    switch (type) {
                        case "AIR":
                            if (!data.booking && !data?.booking?.bounds) {
                                showMessage({
                                    text: "No booking found",
                                    type: "error",
                                    title: "ERROR",
                                });
                                navigate("/");
                            } else {
                                navigate(
                                    "/flight-confirmation?orderNumber=" +
                                        orderNumber,
                                );
                            }
                            break;
                        case "PAYMENT_LINK":
                            if (!data?.payment || !data?.booking) {
                                showError();
                                navigate("/");
                                return;
                            }
                            navigate("/payment-receipt", {
                                state: data,
                            });
                            break;
                        default:
                            showError();
                            break;
                    }
                })
                .catch((error) => {
                    displayErrorMessage(error);
                    console.log(error);
                    result = {
                        status: "error",
                        error: error?.message || "Unknown error",
                    };
                })
                .finally(() => {
                    mimir.log(buildMimirPayload(result));
                });
        }
    }, []);

    const showError = () => {
        showMessage({
            text: "Une erreur s'est produite lors de la confirmation de votre commande. Veuillez contacter le support afin de vérifier si votre paiement a bien été effectué avant de tenter un nouveau paiement.",
            type: "error",
            title: t("paymentError"),
        });
        navigate("/");
    };

    return (
        <>
            <CommonBanner
                heading={t("ConfirmingOrder")}
                pagination="pagination"
            />
            <div className="w-100 h-screen  d-flex  justify-content-center align-items-center ">
                <l-square
                    size="40"
                    stroke="3.5"
                    speed="1"
                    color="black"
                ></l-square>
            </div>
        </>
    );
};

export default ConfirmOrderPage;
